import React from "react";
import "./AuthModal.scss";

interface AuthModalProps {
  heading?: React.ReactNode;
  paragraph?: React.ReactNode;
  children?: React.ReactNode;
  step?: number;
}

const AuthModal: React.FC<AuthModalProps> = ({
  heading,
  paragraph,
  children,
  step,
}) => {
  const renderParagraph = () => {
    if (typeof paragraph === "string") {
      const parts = paragraph.split(/<br\s*\/?>|\n/gi);
      return parts.map((line, idx) => (
        <React.Fragment key={idx}>
          {line}
          {idx < parts.length - 1 && <br />}
        </React.Fragment>
      ));
    }
    return paragraph;
  };

  return (
    <div className="successor-auth-modal">
      {step && (
        <div className="successor-auth-modal__steps">
          Krok {step}/<span>3</span>
        </div>
      )}
      <div className="successor-auth-modal__heading">{heading}</div>

      <div className="successor-auth-modal__paragraph">{renderParagraph()}</div>

      {children && (
        <div className="successor-auth-modal__extra">{children}</div>
      )}
    </div>
  );
};

export default AuthModal;
